import { createCRUDEndpoints } from '@/api/factory/crud';
import { AdJSON } from '@/store/modules/ads/ad';
import { PublishStatus } from '@/store/types';
import httpClient from '@/api/http-client';
import { RequestConfig } from '../types';

export type ListParams = {
  name?: string;
  search?: string;
  status?: PublishStatus | string;
  completed?: boolean | string;
  scheduled?: boolean | string;
  page?: string | number;
  sort?: string;
  direction?: 'asc' | 'desc';
  products?: number[];
  countries?: number[];
};

export type ActiveParams = {
  countries?: number[];
  products?: string[];
};

export const {
  list,
  get,
  store,
  remove,
  restore,
} = createCRUDEndpoints<AdJSON, ListParams>({
  slug: {
    base: 'ads',
    list: 'ads',
    get: 'ad',
    store: 'ad',
    remove: 'ad'
  }
});

export function active(params?: ActiveParams, config?: RequestConfig) {
  return httpClient.get<AdJSON>('ads/active', { params, ...config });
}

export function listAll(
  params?: {
    search?: string;
    status?: PublishStatus;
    products?: number[];
    countries?: number[];
  },
  config?: RequestConfig,
) {
  return httpClient.get<AdJSON[]>('ads/list', { params, ...config });
} 